// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brandhub-spacer{height:7rem}.brandhub-spacer--color-primary{background:var(--base-color)}.brandhub-spacer--color-inverted{background:var(--text-on-base-color)}.brandhub-spacer--color-theme{background:var(--campaign-gradient)}", ""]);
// Exports
module.exports = exports;
